import React from 'react';
import '../css/statssection.css';

const StatsSection = () => {
  return (
    <section className="stats-section">
      <div className="stats-container">
        <div className="stats-content">
          <h2 className="stats-title">
            Tu CX no debería<br />
            <span className="title-highlight">depender del equipo técnico</span>
          </h2>
        </div>
      </div>
    </section>
  );
};

export default StatsSection; 